<template>
    <b-modal
        size="md"
        v-model="modalShow"
        title="質問デッキ編集"
        @ok="handleOk"
        @cancel="close"
        @hidden="close">
        <form
            v-if="healthSurveyTemplate !== null"
            @submit.stop.prevent="onSubmit">
            <div class="row">
                <div class="col-12">
                    <div class="form-group m-form__group">
                        <label for="name">タイトル</label>
                        <input
                            v-model="healthSurveyTemplate.name"
                            :disabled="inProgress"
                            type="text"
                            id="name"
                            placeholder="質問デッキのタイトルを入力"
                            class="form-control"
                            :class="{ 'is-invalid' : errors.name }">
                        <div
                            v-if="errors.name"
                            class="invalid-feedback d-block mt-1">
                            {{ errors.name[0] }}
                        </div>
                    </div>
                </div>
            </div>
        </form>

        <div slot="modal-footer">
            <button
                class="btn btn-yokumiru-orange float-right"
                :disabled="inProgress"
                @click="handleOk">
                保存
            </button>
            <button
                class="btn btn-yokumiru-gray float-right mr-2"
                :disabled="inProgress"
                @click="close">
                キャンセル
            </button>
        </div>
    </b-modal>
</template>

<script>
import constants from '../../../constants'
import YokumiruHelper from '../../../YokumiruHelper'

export default {
    data: function () {
        return {
            helper: YokumiruHelper,
            inProgress: false,
            modalShow: false,
            healthSurveyTemplate: null,
            errors: {},
        }
    },

    computed: {},

    created: function () {
        bus.$on('open-modal-admin-edit-health-survey-template', this.open)
    },

    beforeDestroy: function () {
        bus.$off('open-modal-admin-edit-health-survey-template')
    },

    methods: {
        /**
         * モーダル表示
         */
        open: function (healthSurveyTemplate) {
            this.healthSurveyTemplate = {...healthSurveyTemplate}
            this.modalShow = true
        },

        /**
         * モーダルを閉じる
         */
        close: function () {
            this.errors = {}
            this.modalShow = false
        },

        /**
         * 保存ボタン押下時
         * @param {object} e
         */
        handleOk: function (e) {
            e.preventDefault()
            this.onSubmit()
        },

        /**
         * 質問デッキ編集
         */
        onSubmit: async function () {
            if (this.inProgress) return
            this.inProgress = true

            const endpoint = constants.admin.health_survey_templates.endpoint.base
            const params = {
                name: this.healthSurveyTemplate.name,
            }

            await axios.put(`${endpoint}/${this.healthSurveyTemplate.id}`, params)
                .then(() => {
                    bus.$emit('alert-success', '質問デッキを編集しました。')
                    bus.$emit('health-survey-template-added')
                    this.errors = {}
                    this.close()
                })
                .catch(({response}) => {
                    if (response.hasOwnProperty('data') && response.data.hasOwnProperty('errors')) {
                        bus.$emit('alert-danger')
                        this.errors = response.data.errors
                    }
                    else {
                        bus.$emit('alert-danger', 'システムエラーが発生しました。')
                    }
                })

            this.inProgress = false
        },
    },
}
</script>
